import Loadable from '../../components/loadable';

const ShowTask = Loadable({
  loader: () => import('../../pages/tasks/show_task'),
  type: 'drawer',
});

angular.module('gym').value('ShowTask', ShowTask);
